import HrActionButton from './hr-list-action';
import DataGridBlankLabel from '../../../shared/components/ui/datagrid/datagrid-blank-label';
import { IColumnAction } from '../../../shared/interfaces/datagrid.interface';

export const columns: IColumnAction[] = [
  {
    field: 'code',
    headerName: 'Employee Code',
    width: 132,
    disableColumnMenu: true,
    renderCell: (e): any => {
      return DataGridBlankLabel(e.row.code);
    },
  },

  {
    field: 'lastname',
    headerName: 'Last Name',
    width: 120,
    disableColumnMenu: true,
    renderCell: (e): any => {
      return DataGridBlankLabel(e.row.lastname);
    },
  },

  {
    field: 'firstname',
    headerName: 'First Name',
    width: 120,
    disableColumnMenu: true,
    renderCell: (e): any => {
      return DataGridBlankLabel(e.row.firstname);
    },
  },

  {
    field: 'middlename',
    headerName: 'Middle Name',
    width: 120,
    disableColumnMenu: true,
    renderCell: (e): any => {
      return DataGridBlankLabel(e.row.middlename);
    },
  },

  {
    field: 'company',
    headerName: 'Affiliate Description',
    width: 300,
    disableColumnMenu: true,
    renderCell: (e): any => {
      return DataGridBlankLabel(e.row.company);
    },
  },

  {
    field: 'department',
    headerName: 'Department',
    width: 250,
    disableColumnMenu: true,
    renderCell: (e): any => {
      return DataGridBlankLabel(e.row.department);
    },
  },

  {
    field: 'position',
    headerName: 'Position',
    width: 250,
    disableColumnMenu: true,
    renderCell: (e): any => {
      return DataGridBlankLabel(e.row.position);
    },
  },

  {
    field: 'hiring_date',
    headerName: 'Date Hired',
    width: 100,
    disableColumnMenu: true,
    renderCell: (e): any => {
      return DataGridBlankLabel(e.row.hiring_date);
    },
  },

  {
    field: 'clearance_application_date',
    headerName: 'Date of Clearance Application',
    width: 240,
    disableColumnMenu: true,
    renderCell: (e): any => {
      return DataGridBlankLabel(e.row.clearance_application_date);
    },
  },

  {
    field: 'last_working_day',
    headerName: 'Last Working Day',
    width: 150,
    disableColumnMenu: true,
    renderCell: (e): any => {
      return DataGridBlankLabel(e.row.last_working_day);
    },
  },

  {
    field: 'reason',
    headerName: 'Reason',
    width: 250,
    disableColumnMenu: true,
    renderCell: (e): any => {
      return DataGridBlankLabel(e.row.reason);
    },
  },

  {
    field: 'status',
    headerName: 'Status',
    width: 100,
    disableColumnMenu: true,
    renderCell: (e): any => {
      return DataGridBlankLabel(e.row.status);
    },
  },
  {
    field: 'actions',
    headerName: '',
    align: 'left',
    type: 'actions',
    width: 120,
    disableColumnMenu: true,
    getActions: ({ row: { slug, status } }): any => {
      if (!slug) return [];

      return [<HrActionButton key={slug} slug={slug} status={status} />];
    },
  },
];
